/*
 * @Author: your name
 * @Date: 2021-06-15 17:38:41
 * @LastEditTime: 2021-07-28 02:32:48
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \yijiu_shopmall_h5\src\public\share.js
 */
// import { sendBaseRequest } from '@/assets/public'
import wx from "weixin-js-sdk"
import urlconfig from '../../config.js'
import http from '../../http.js'
import Vue from "vue";
function GetRequest() {
    var hash = decodeURI(location.hash)
    var history = decodeURI(location.search)
    var theRequest = new Object();
    var str = '', strs;
    if (history && hash) {
        var hashstr = hash.substr(hash.indexOf("?") + 1);
        var historystr = history.substr(history.indexOf("?") + 1);
        str = historystr + "&" + hashstr
    } else {
        var hashstr = hash.substr(hash.indexOf("?") + 1);
        var historystr = history.substr(history.indexOf("?") + 1);
        str = historystr || hashstr
    }
    console.log(hashstr)
    strs = str.split("&");
    console.log(strs)
    for (var i = 0; i < strs.length; i++) {
        theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
    }
    console.log(theRequest)
    return theRequest;
};
class Share {
    constructor(el, store, page) {
        this.getData(el, store, page)
    }
    async getData(el, store, page) {
        console.log('page:', el.startUrl)
        let { content, status } = await http('Base.getGzShare', {
            // url: location.href.split('#')[0],
            url: el.startUrl
        })
        if (status != 200) { return }
        wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: content.appId, // 必填，公众号的唯一标识
            timestamp: content.time + '', // 必填，生成签名的时间戳
            nonceStr: content.rand, // 必填，生成签名的随机串
            signature: content.sign,// 必填，签名，见附录1
            jsApiList: ['hideMenuItems', 'updateAppMessageShareData', 'hideAllNonBaseMenuItem', 'showMenuItems', 'onMenuShareAppMessage', 'onMenuShareTimeline']
        });
        wx.ready(function () {
            wx.hideAllNonBaseMenuItem();
            store.commit('shareFg', page)
            // wx.showMenuItems({
            //     menuList: ["menuItem:share:appMessage", "menuItem:share:timeline"] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
            // });
            // let shareInfo = {
            //     title: el.goods.goods_name, // 分享标题
            //     desc: el.goods.content ? el.goods.content : '我发现了一款超值宝贝，快来看看吧~', // 分享描述
            //     link: el.url, // 分享链接，该链接域名必须与当前企业的可信域名一致'
            //     imgUrl: el.goods.images, // 分享图标
            //     success: function (res) {
            //         console.log(res, '分享成功')
            //         console.log('分享111')
            //     },// 用户确认分享后执行的回调函数
            //     cancel: function () {
            //         console.log('分享111')
            //     }// 用户取消分享后执行的回调函数
            // };
            // wx.onMenuShareAppMessage(shareInfo);
            // wx.onMenuShareTimeline(shareInfo);
        });
    }
}

export default Share;

